/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The access type of the platform catalog.
<br/><br/>
The enum represents the following three access types:<br/>
`PUBLIC`: The catalog is visible to all registered and active API users<br/>
`ALL_CUSTOMERS`: The catalog is visible to all of the supplier's customers. Do not give access to the catalog to other users than customers of the given supplier!<br/>
`PROTECTED`: The catalog is a `private` catalog and only visible to a specific group of users. Do `ONLY` give access to the catalog if it is present in the particular user's catalog listing!

 */
export type CatalogAccessType =
  (typeof CatalogAccessType)[keyof typeof CatalogAccessType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CatalogAccessType = {
  PUBLIC: "PUBLIC",
  ALL_CUSTOMERS: "ALL_CUSTOMERS",
  PROTECTED: "PROTECTED",
} as const;
